<footer [ngClass]="{ showFooter: !mostrarFooter }">
  <div class="first">
    <div class="first-container">
      <ng-container *ngIf="configBloque?.mostrar_newsletter === 'true'">
        <div class="newsletter-container container-left">
          <div class="txt-newsletter">{{ configBloque?.texto_uno }}</div>
          <div class="newsform">
            <form [formGroup]="formulario" (ngSubmit)="newsletterSubscribe()" novalidate>
              <input type="text" formControlName="email" [placeholder]="configBloque?.text_placeholder_input" />
              <button type="submit" class="subButton">{{ configBloque?.texto_boton }}</button>
            </form>
          </div>
        </div>
        <ng-container *ngIf="configBloque?.mostrar_rrss === 'true'">
          <span class="spacer"></span>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="configBloque?.mostrar_rrss">
        <div class="rrss-container">
          <div class="txt-rrss txt-rrss-aligned">{{ configBloque?.texto_dos }}</div>
          <div class="rrss-wrapper">
            <div class="rrss">
              <ng-container *ngIf="configBloqueFooter.facebook?.[0]">
                <a class="rrssbutton" [href]="configBloqueFooter.facebook" aria-label="Facebook">
                  <app-icon-facebook-material></app-icon-facebook-material>
                </a>
              </ng-container>
              <ng-container *ngIf="configBloqueFooter.twitter?.[0]">
                <a class="rrssbutton" [href]="configBloqueFooter.twitter" aria-label="Twitter">
                  <app-icon-twitter [color]="'#fff'"></app-icon-twitter>
                </a>
              </ng-container>
              <ng-container *ngIf="configBloqueFooter.yt?.[0]">
                <a class="rrssbutton" [href]="configBloqueFooter.yt" aria-label="YouTube">
                  <app-icon-youtube></app-icon-youtube>
                </a>
              </ng-container>
              <ng-container *ngIf="configBloqueFooter.insta?.[0]">
                <a class="rrssbutton" [href]="configBloqueFooter.insta" aria-label="Instagram">
                  <app-icon-instagram></app-icon-instagram>
                </a>
              </ng-container>
              <ng-container *ngIf="configBloqueFooter.telegram?.[0]">
                <a class="rrssbutton" [href]="configBloqueFooter.telegram" aria-label="Telegram">
                  <app-icon-telegram></app-icon-telegram>
                </a>
              </ng-container>
            </div>
            <app-google-news-banner class="google-news-footer"></app-google-news-banner>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="second">
    <div class="second-container">
      <nav class="footer-nav">
        <div class="footer-header">SECCIONES</div>
        <ng-container *ngFor="let canal of subcanales?.slice(0, 5); trackBy: trackByCanal">
          <a class="item-canal link-spacer" [routerLink]="['/seccion', canal.idSubcanal, canal.nombreSubCanal | kebabCase]">
            {{ canal.nombreSubCanal }}
          </a>
        </ng-container>
      </nav>

      <nav class="footer-nav">
        <div class="footer-header">MÁS CONTENIDO</div>
        <ng-container *ngFor="let canal of subcanales?.slice(5, 9); trackBy: trackByCanal">
          <a class="item-canal link-spacer" [routerLink]="['/seccion', canal.idSubcanal, canal.nombreSubCanal | kebabCase]">
            {{ canal.nombreSubCanal }}
          </a>
        </ng-container>
      </nav>

      <ng-container *ngIf="configBloque">
        <nav class="footer-nav text-right">
          <div class="footer-header">{{ configBloque.texto_grupo }}</div>
          <ng-container *ngIf="configBloque.link_quienes_somos">
            <a class="link-spacer" [href]="configBloque.link_quienes_somos">Quiénes somos</a>
          </ng-container>
          <ng-container *ngIf="configBloque.link_nuestros_sites">
            <a class="link-spacer" [href]="configBloque.link_nuestros_sites">Nuestros Sites</a>
          </ng-container>
          <ng-container *ngIf="configBloque.link_contacto">
            <a class="link-spacer" [href]="configBloque.link_contacto"> Contacto <app-icon-email></app-icon-email> </a>
          </ng-container>
          <ng-container *ngIf="configBloque.link_tienda && configBloque.texto_tienda">
            <a class="link-spacer" [href]="configBloque.link_tienda">{{ configBloque.texto_tienda }}</a>
          </ng-container>
          <ng-container *ngIf="configBloque.link_revista && configBloque.texto_revista">
            <a class="link-spacer" [href]="configBloque.link_revista">{{ configBloque.texto_revista }}</a>
          </ng-container>
        </nav>
      </ng-container>

      <ng-container *ngIf="configBloque || cookieConfig">
        <nav class="footer-nav text-right">
          <div class="footer-header">LEGALES</div>
          <ng-container *ngIf="configBloque?.link_aviso_legal">
            <a class="link-spacer" [href]="configBloque.link_aviso_legal" target="_blank">Aviso Legal</a>
          </ng-container>
          <ng-container *ngIf="configBloque?.link_privacidad">
            <a class="link-spacer" [href]="configBloque.link_privacidad" target="_blank">Política de Privacidad</a>
          </ng-container>
          <ng-container *ngIf="configBloque?.link_cookies">
            <a class="link-spacer" [routerLink]="'/politica-cookies'">Política de Cookies</a>
          </ng-container>
          <ng-container *ngIf="configBloque?.link_accesibilidad">
            <a class="link-spacer" [href]="configBloque.link_accesibilidad" target="_blank">Accesibilidad</a>
          </ng-container>
          <ng-container *ngIf="cookieConfig">
            <a class="link-spacer" (click)="configureCookies()" target="_blank">Configurar cookies</a>
          </ng-container>
        </nav>
      </ng-container>
    </div>
  </div>
</footer>

<ng-container *ngIf="showModal">
  <div class="custom-modal--container" (click)="closeModal()">
    <div class="text">
      <h3>Gracias por suscribirte</h3>
      <div [innerHTML]="mensaje"></div>
    </div>
  </div>
</ng-container>
